import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLightning: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconLightning"><Path d="M9.08339 2C8.72668 2 8.39697 2.19002 8.21814 2.49866L3.00343 11.4987C2.61716 12.1653 3.0982 13 3.86868 13H8.8291L6.53658 20.6417C6.2458 21.611 7.41372 22.3495 8.16469 21.6712L21.3719 9.7421C22.0514 9.12838 21.6172 8 20.7016 8H15.3101L17.5865 3.44721C17.919 2.78231 17.4355 2 16.6921 2H9.08339Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLightning;
